// extracted by mini-css-extract-plugin
export default {"alert":"calculation-hints_alert__JIC60","text":"calculation-hints_text__YvlG5"};